import { mutations } from './mutations';
import { getters } from './getters';
import { SessionState } from './state';

const defaultState: SessionState = {
  filtersMap: {},
  filterHashMap: {},
  advancedSearchVisibleMap: {},
  tableOptionsMap: {},
  choiceCache: {}
};

export const sessionModule = {
  state: defaultState,
  mutations,
  getters
};
